import DealPageTile from './DealPageTile';

export default DealPageTile;
